import { css } from '@emotion/core'
import React, { type ReactNode } from 'react'

const tabsRowCenteredCss = css`
  display: flex;
  justify-content: center;
  overflow: hidden;
  background: var(--gray00a);
  border-bottom: 1px solid var(--gray20);
`

const tabsRowCss = css`
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
  background: var(--gray00a);
  border-bottom: 1px solid var(--gray20);
`

const tabCss = css`
  background: var(--gray00a);
  color: var(--gray100);
  cursor: default;
  flex-shrink: 0;
  height: 48px;
  line-height: 48px;
  min-width: 90px;
  max-width: 360px;
  padding: 0 16px;
  text-align: center;
  font-size: var(--text-size-b);
  white-space: nowrap;
  pointer-events: none;
  display: flex;
  align-items: center;
`

export type TabItem = {
  key: string
  content: ReactNode
}

export function TabsSkeleton({ tabs, centered }: { tabs: TabItem[]; centered?: boolean }): JSX.Element {
  return (
    <div css={centered ? tabsRowCenteredCss : tabsRowCss} aria-hidden="true">
      {tabs.map(({ key, content }) => (
        <div key={key} css={tabCss}>
          {content}
        </div>
      ))}
    </div>
  )
}
